import { slideToggle, toggleAria } from "../utils.js";
import "core-js/es/array";

export default class Timeline {

    constructor() {

        this.timeline = document.getElementById('ncc-timeline');
        if(this.timeline) this.bindTimeline();

    }

    bindTimeline() {

        if(window.msCrypto) {
            document.body.classList.add('IE11');
        }       

        //init controller
        var controller = new ScrollMagic.Controller();

        const navStop = document.getElementById('pin-nav-trigger').offsetHeight - document.getElementById('pin-nav').offsetHeight;
        const itemHeight = document.getElementById('trigger1').offsetHeight;

        new ScrollMagic.Scene({triggerElement: '#pin-nav' , duration: navStop - 200, triggerHook: "onLeave"})
            .setPin('#pin-nav')
            //.addIndicators({name:'nav - (duration: 300)'})
            .addTo(controller);

        for (let index = 1; index <= Array.from(document.querySelectorAll('.c-timeline__content-item')).length; index++) {
            
            // new ScrollMagic.Scene({triggerElement: '#trigger' + index , duration: 500})
            // .setPin('#pin' + index)
            // //.addIndicators({name: index + ' (duration: 300)'})
            // .addTo(controller);

            new ScrollMagic.Scene({triggerElement: '#trigger' + index , duration: itemHeight})
            .setClassToggle('#pin' + index, "visible")
            .addTo(controller);

            

            new ScrollMagic.Scene({
                    triggerElement: '#trigger' + index,
                    triggerHook: 0.5, // show, when scrolled 10% into view
                    duration: "100%", // hide 10% before exiting view (80% + 10% from bottom)
                    offset: 50 // move trigger to center of element
                })
                .on("enter", function (e) {
                    Array.from(document.querySelectorAll('.c-timeline__nav-item')).forEach(el => el.classList.remove('c-timeline__nav-item--active'));
                    document.getElementById('timeline-nav-' + e.target.triggerElement().dataset.nav ).classList.add('c-timeline__nav-item--active');
                })
                .setClassToggle('#reveal' + index, "visible") // add class to reveal
                //.addIndicators() // add indicators (requires plugin)
                .addTo(controller);

        }

    }
}